/**
 * صفحة الهبوط التعريفية (النطاق القديم ufuq-iq.com):
 * الافتتاحية السينمائية + شعار أفق فقط — بلا لوحة تحكم ولا روابط دخول.
 */
import { createRoot } from 'react-dom/client'

import IntroSplash from './components/IntroSplash'

createRoot(document.getElementById('root')!).render(<IntroSplash loop />)
